var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 11,
    y: 1,
    fill: "currentColor",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 11,
    y: 1,
    fill: "currentColor",
    opacity: 0.29,
    transform: "rotate(30 12 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 11,
    y: 1,
    fill: "currentColor",
    opacity: 0.43,
    transform: "rotate(60 12 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 11,
    y: 1,
    fill: "currentColor",
    opacity: 0.57,
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 11,
    y: 1,
    fill: "currentColor",
    opacity: 0.71,
    transform: "rotate(120 12 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 11,
    y: 1,
    fill: "currentColor",
    opacity: 0.86,
    transform: "rotate(150 12 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 11,
    y: 1,
    fill: "currentColor",
    transform: "rotate(180 12 12)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "discrete",
    dur: "0.75s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.36cd4c174a07bea3d41dbc2f4e7c0ef5.svg";
export { ForwardRef as ReactComponent };